import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import SectionView from "../../layout/section/SectionView";
import DataGrid from "../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import {option, Option} from "ts-option";
import SelectLeadStatus from "../../lead/statusSelector/SelectLeadStatus";
import {RootState} from "../../../store/reducer/root/RootState";
import {Dispatch} from "redux";
import LeadStatusSettings, {LeadStatusSettingsName} from "../../../model/lead/LeadStatusSetting";
import {connect} from "react-redux";
import {updateLeadStatusConfig} from "../../../store/action/leadStatus/leadStatus";
import Toast from "../../helper/Toast";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import Spinner from "../../../hiberUiKit/src/atoms/Spinner/Spinner";

const spinner = require("./../../../../resources/hiber/img/spinner-orange.png");

interface IReduxProps {
	leadStatusConfig: Option<LeadStatusSettings[]>;
}

interface IDispatchProps {
	updateLeadStatusConfig: (lss: LeadStatusSettings) => void;
}

type Props = IReduxProps & IDispatchProps;

class LeadStatusConfig extends React.Component<Props, {}> {

	render() {
		return (
			<Boxed style={{overflowX: "visible"}}>
				<PageHeaderView header={"Lead status config"}/>
				{this.props.leadStatusConfig.map(lsc =>
					<PageContentView>
						<SectionView>
							<DataGrid>
								<thead>
								<tr>
									<th style={{width: "40%"}}>Action</th>
									<th style={{width: "60%"}}>Status</th>
								</tr>
								</thead>
								<tbody>
								{lsc.map((item, index) =>
									<tr key={index}>
										<td>
											{this.getActionLabel(item.settingsName)}
										</td>
										<td>
											<SelectLeadStatus
												selectedId={option(item.statusId)}
												clearable={false}
												onChanged={(ls) => ls.map(
													s => this.props.updateLeadStatusConfig(item.copy({statusId: s.id})))
												}/>
										</td>
									</tr>)}
								</tbody>
							</DataGrid>
						</SectionView>
					</PageContentView>).getOrElse(<Spinner imgUrl={spinner} size={72}/>)
				}
			</Boxed>
		)
	}

	getActionLabel(settingsName: string): string {
		switch (settingsName) {
			case LeadStatusSettingsName.LeadStatusEngineerOnRoute:
				return "Lead status for Engineer on Route";
			case LeadStatusSettingsName.LeadStatusSurveyDone:
				return "Lead status for Survey done";
			case LeadStatusSettingsName.LeadStatusSurveyInProgress:
				return "Lead status for Survey in progress";
			case LeadStatusSettingsName.LeadStatusEnquiryLost:
				return "Lead status for Enquiry lost";
			default:
				settingsName;
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		leadStatusConfig: state.leadStatus.leadStatusConfig
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateLeadStatusConfig: (lss: LeadStatusSettings) => dispatch(
			updateLeadStatusConfig(lss, () => {Toast.success("Lead status config updated", "Lead status config")},
				() => {Toast.error("Sorry, something went wrong. Try again later.", "Lead status config")})),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadStatusConfig)
